export { default as EdgeStack } from './EdgeStack'
export { edgeStack, edgeStackEmitter } from '@/plugins/edgeStack'
